// extracted by mini-css-extract-plugin
export var body = "_fe-0";
export var sectionHeader = "_fe-4";
export var shortcutColumns = "_fe-2";
export var shortcutList = "_fe-1";
export var shortcutSection = "_fe-3";